import script from "./ComplexMode.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComplexMode.vue?vue&type=script&lang=ts&setup=true"

import "./ComplexMode.vue?vue&type=style&index=0&id=749467ed&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-749467ed"]])

export default __exports__